import { FileText, File, Table, Presentation, type LucideIcon } from 'lucide-react';

interface FileIconConfig {
  icon: LucideIcon;
  color: string;
}

const SUPPORTED_FORMATS_ICONS: Record<string, FileIconConfig> = {
  'application/pdf': { icon: FileText, color: 'text-red-500' },
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document': {
    icon: FileText,
    color: 'text-blue-500'
  },
  // 'application/msword': { icon: FileText, color: 'text-blue-500' },
  'text/plain': { icon: File, color: 'text-gray-500' },
  'text/markdown': { icon: File, color: 'text-purple-500' },
  // 'application/vnd.ms-excel': { icon: Table, color: 'text-green-500' },
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': {
    icon: Table,
    color: 'text-green-500'
  },
  'application/vnd.openxmlformats-officedocument.presentationml.presentation': {
  icon: Presentation,
    color: 'text-orange-500'
}
};

interface FileIconProps {
  fileType: string;
  className?: string;
}

const FileIcon: React.FC<FileIconProps> = ({ fileType, className = '' }) => {
  const { icon: Icon, color } = SUPPORTED_FORMATS_ICONS[fileType] || { icon: File, color: 'text-gray-500' };
  return <Icon className={`${className} ${color}`} />;
};

export default FileIcon;
